import React, { useState } from 'react';
import { ChatInterface } from './ChatInterface';
import { ResultsGallery } from './ResultsGallery';
import { QueryResult } from './types';
import { MessageSquare } from 'lucide-react';

interface ClaudeQueryAppProps {
  onBack?: () => void;
}

export const ClaudeQueryApp: React.FC<ClaudeQueryAppProps> = ({ onBack }) => {
    const [results, setResults] = useState<QueryResult[]>([]);
    const [selectedResults, setSelectedResults] = useState<Set<string>>(new Set());

    const handleAddResult = (result: QueryResult) => {
        setResults(prev => [result, ...prev]);
    };

    const handleToggleResult = (queryId: string) => {
        setSelectedResults(prev => {
            const newSet = new Set(prev);
            if (newSet.has(queryId)) {
                newSet.delete(queryId);
            } else {
                newSet.add(queryId);
            }
            return newSet;
        });
    };

    const handleClearSelection = () => {
        setSelectedResults(new Set());
    };

    const handleDeleteResult = (queryId: string) => {
        setResults(prev => prev.filter(r => r.queryId !== queryId));
        setSelectedResults(prev => {
            const newSet = new Set(prev);
            newSet.delete(queryId);
            return newSet;
        });
    };

    const getSelectedResultsData = (): QueryResult[] => {
        return results.filter(r => selectedResults.has(r.queryId));
    };

    return (
        <div className="h-[calc(100vh-80px)] bg-gray-50 flex flex-col">
            {/* Header */}
            <div className="bg-white border-b px-6 py-4 flex-shrink-0">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg">
                        <MessageSquare size={24} className="text-white" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">Spør bizClick</h1>
                        <p className="text-sm text-gray-500">Still spørsmål til lagerdatabasen i naturlig språk</p>
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 overflow-hidden flex gap-4 p-4">
                {/* Chat Interface - Left Side */}
                <div className="flex-1 flex flex-col min-w-0">
                    <ChatInterface 
                        onAddResult={handleAddResult}
                        selectedResults={getSelectedResultsData()}
                        hasSelectedResults={selectedResults.size > 0}
                        onClearSelection={handleClearSelection}
                    />
                </div>

                {/* Results Gallery - Right Side */}
                <div className="w-96 flex-shrink-0">
                    <ResultsGallery 
                        results={results}
                        selectedResults={selectedResults}
                        onToggleResult={handleToggleResult}
                        onDeleteResult={handleDeleteResult}
                    />
                </div>
            </div>
        </div>
    );
};
